import { useEffect } from "react";
import { useQuery, useSubscription } from "@apollo/client";
import { useDispatch } from "react-redux";
import {
  QUERY_ATTACK_MODE_DATA,
  SUBSCRIBE_ATTACK_MODE_DATA,
  SUBSCRIBE_DRIVER_ATTACK_MODE_STATE_UPDATE,
  SUBSCRIBE_ATTACK_LOSS_UPDATE,
} from "../queries/attackModeQueries";
import {
  setAttackModeData,
  setDriverAttackModeState,
  setAttackLoss,
} from "../../../state/attackModeReducer";

export function QueryAttackModeData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_ATTACK_MODE_DATA);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setAttackModeData(data.getAttackModeData));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeAttackModeData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_ATTACK_MODE_DATA, {
    onData: (x) => {
      const attackModeUpdate = x.data.data.newAttackModeData;
      dispatch(setAttackModeData(attackModeUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeDriverAttackModeStateUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_DRIVER_ATTACK_MODE_STATE_UPDATE, {
    onData: (x) => {
      const updates = x.data.data.newDriverAttackModeStateUpdate;
      updates?.forEach(
        (update: { driver: string; attackModeState: unknown }) => {
          dispatch(
            setDriverAttackModeState({
              driverId: update.driver,
              attackModeState: update.attackModeState,
            }),
          );
        },
      );
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeAttackLossUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_ATTACK_LOSS_UPDATE, {
    onData: (x) => {
      const attackLoss = x.data.data.newAttackLossUpdate;
      if (attackLoss) {
        dispatch(setAttackLoss(attackLoss));
      }
    },
  });
  if (error) {
    console.log(error);
  }
}
